export default {
    INFINITE_TABLE_LICENSE_KEY: "StartDate=2021-06-29|EndDate=2030-01-01|Owner=Adaptable|Type=distribution|TS=1624971462479|C=137829811,1004007071,2756196225,1839832928,3994409405,636616862" || '',
    PUBLISH_TIMESTAMP: 1722345319339 || Date.now(),
    VERSION: "18.1.14" || '--current-version--',
};
